import React from "react";

class TimetableLesson extends React.Component {
  state = {
    isDroppedDown: false,
  };

  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({
      isDroppedDown: !this.state.isDroppedDown,
    });
  }

  render() {
    return (
      <div>
        {this.props.lessons.map((lesson, key) => (
          <div className="lesson--container" key={key}>
            <div className="lesson--div">
              <div className="lesson--class-name">
                <strong>{lesson.class_name}</strong>
              </div>
              <div className="lesson--period-number">
                <strong>Period</strong>
                {lesson.period_name}
              </div>
              {typeof lesson.start_at.date !== "undefined" &&
                lesson.start_at.date !== "na" && (
                  <div className="lesson--start">
                    <strong>Start:</strong>{" "}
                    {lesson.start_at.date.substring(10, 16)}
                  </div>
                )}
              {lesson.employee_name !== "na" && (
                <div className="lesson--employee-name">
                  {lesson.employee_name}
                </div>
              )}
              <div className="lesson--room-name">
                <strong>Location:</strong>
                {lesson.room_name}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default TimetableLesson;
